module.exports = __webpack_public_path__ + "static/img/appriana-mobile.6147410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appriana-mobile.png
// module id = cA39
// module chunks = 1